import type { UpdateQuantityPayload } from "@model/Cart.model";
import { CART_SET_QUANTITY } from "./CartActionTypes";

export const setCartItemQuantityAction =
  (payload: UpdateQuantityPayload) =>
  (dispatch: any) => {
    dispatch({ type: CART_SET_QUANTITY, payload });
  };
